export class ChatInputLanguageManager {
  getLanguageCode(mode) {
    switch (mode) {
      case "EN":
        return "en";
      case "MA":
        return "mr";
      case "HI":
        return "hi";
      case "GJ":
        return "gu";
      default:
        return "en";
    }
  }

  getInputLanguageMode(languageCode) {
    switch (languageCode) {
      case "en":
        return "EN";
      case "mr":
        return "MA";
      case "hi":
        return "HI";
      case "gu":
        return "GJ";
      default:
        return "MA";
    }
  }
}
